import { useQuery } from '@tanstack/react-query';
import { teamService } from '@/services/team/teamService';
import { teamKeys } from './queryKeys';

export const useTeamMembers = () => {
  return useQuery({
    queryKey: teamKeys.members(),
    queryFn: teamService.getTeamMembers,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
